import AboutPage from '../Pages/AboutPage'
import ProjectsPage from '../Pages/ProjectsPage'
import ProjectPage from '../Pages/ProjectPage';
import StudiesPage from '../Pages/StudiesPage';
import ContactPage from '../Pages/ContactPage';
import NotFoundPage from '../Pages/NotFoundPage';

import {
  Routes,
  Route
} from "react-router-dom"

function Public(props) {
  return (
      <Routes> 
        <Route path='/' element={<AboutPage language={props.language} uk={props.uk} />} />
        <Route path='/projects' element={<ProjectsPage language={props.language} uk={props.uk} />} />
        <Route path='/projects/:id' element={<ProjectPage language={props.language} uk={props.uk} />} />
        <Route path='/studies' element={<StudiesPage language={props.language} uk={props.uk} />} />
        <Route path='/contact' element={<ContactPage language={props.language} uk={props.uk} />} />

        <Route path='*' element={<NotFoundPage language={props.language} uk={props.uk} />} />
      </Routes>
  );
}
 
export default Public;
